import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = false

import storage from "./storage";
Vue.use(storage)

import vuetify from './plugins/vuetify'
import VueTelInputVuetify from 'vue-tel-input-vuetify/lib';

Vue.use(VueTelInputVuetify, {
  vuetify,
});


Object.defineProperty(String.prototype, 'capitalize', {
  value: function() {
    return this.charAt(0).toUpperCase() + this.slice(1);
  },
  enumerable: false
});

import * as VueGoogleMaps from 'vue2-google-maps-withscopedautocomp'
Vue.use(VueGoogleMaps, {
  load: {
    // eslint-disable-next-line no-undef
    key: wgCalc.apiKey,
    libraries: ['places','drawing'], // This is required if you use the Autocomplete plugin
  },
  installComponents: true
})

import './scss/style.scss'
import i18n from './i18n'

Vue.filter("formatNumber", function (value) {
  return new Intl.NumberFormat().format(value) ; // displaying other groupings/separators is possible, look at the docs
});

Vue.prototype.wgCalc = window.wgCalc;

new Vue({
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#solarCalcApp')
